import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleRightMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chevron-triangle-right-medium, dropdown, caret"} maskId="square-filled-radius-0-stroke-1-IconChevronTriangleRightMedium"><path d="M16.7744 12L9 18.5781V5.42188L16.7744 12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChevronTriangleRightMedium;
